import React from 'react';
import { CustomEventTypes } from '../../globals';
import useForceUpdate from '../reactUtils/useForceUpdate';
import useEventListener from '../reactUtils/useEventListener';

let currentDropdownList = null;

DropDownLayer.setDropdownList = function(dropdownList)
{
	// console.log(dropdownList);
	currentDropdownList = dropdownList;
	document.dispatchEvent(new CustomEvent(CustomEventTypes.dropdownChanged));
};

export default function DropDownLayer(props)
{
	const forceUpdate = useForceUpdate();
	useEventListener(CustomEventTypes.dropdownChanged, () => forceUpdate(), document);

	return (
		<div>
			{currentDropdownList}
		</div>
	);
}
